import React from 'react'
import { ExclamationTriangleFill } from 'react-bootstrap-icons'
import { Box } from '@mui/material'
import CloseIcon from '../../../../Assets/Images/Login/no.svg'

export default function ContentProductNegativeMargin({ setCloseWarningModal }) {
  const handleCloseWarningModal = () => {
    setCloseWarningModal(false)
  }

  return (
    <Box
      className="modal-box-message"
      data-testid="container-modal-negative-margin"
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <img
        src={CloseIcon}
        alt="close"
        onClick={handleCloseWarningModal}
        data-testid="btn-close-modal-negative-margin"
        style={{
          position: 'absolute',
          top: '25px',
          right: '30px',
          cursor: 'pointer',
        }}
      />
      <ExclamationTriangleFill
        style={{
          fontSize: '40px',
          color: '#FF2A40',
          marginBottom: '19px',
        }}
        data-testid="icon-warning-negative-margin"
      />
      <p
        data-testid="label-negative-margin-message"
        style={{
          textAlign: 'center',
          fontSize: '20px',
          fontWeight: 'semibold',
        }}>
        La orden de venta requiere aprobación. <br />
        Los precios otorgados, deben ser mayor al costo del producto.
      </p>
    </Box>
  )
}
